module.exports = __webpack_public_path__ + "static/media/tooth_chart.a02e463f.svg";